import axiosInstance from "helpers/api";
import { getISODate } from "helpers/utils";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InlineTaskList from "./InlineTaskList";
import { LeadDetailsTaskProps, LeadTaskItem, LeadTaskData } from "interfaces/lead";

const LeadDetailsTask = ({ tasks, handleSearchTask, onWorkflowProgressRefresh }: LeadDetailsTaskProps) => {
  const [taskItems, setTaskItems] = useState<LeadTaskItem[]>([]);
  
  let { id } = useParams();

  useEffect(() => {
    setTaskItems(tasks);
  }, [tasks]);

  const handleCreateTask = async (taskData: LeadTaskData) => {
    try {
      const response = await axiosInstance.post(`/leads/${id}/tasks`, {
        task: taskData.task,
        status: taskData.task_status,
        priority: taskData.priority,
        due_date: taskData.due_date ? getISODate(new Date(taskData.due_date)) : null,
      });
      setTaskItems(response.data.data.tasks);
      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  const handleUpdateTask = async (taskId: string, taskData: LeadTaskData) => {
    try {
      const response = await axiosInstance.patch(
        `/leads/${id}/tasks/${taskId}`,
        {
          task: taskData.task,
          status: taskData.task_status,
          priority: taskData.priority,
          due_date: taskData.due_date ? getISODate(new Date(taskData.due_date)) : null,
        }
      );
      setTaskItems(response.data.data.tasks);
      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  const handleDeleteTask = async (taskId: string) => {
    try {
      await axiosInstance.delete(`/leads/${id}/tasks/${taskId}`);
      setTaskItems((prevTasks: LeadTaskItem[]) => prevTasks.filter((task: LeadTaskItem) => task.id !== taskId));
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const handleToggleTask = async (task: LeadTaskItem) => {
    try {
      const response = await axiosInstance.patch(
        `/leads/${id}/tasks/${task.id}`,
        {
          is_completed: !task.is_completed,
          status: task.is_completed ? "Pending" : "Completed",
        }
      );
      setTaskItems(response.data.data.tasks);

      if (!task.is_completed) {
        try {
          const progressionResponse = await fetch(`/api/workflow/tasks/${task.id}/complete`, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'X-User-ID': localStorage.getItem('userId') || '',
              'X-User-JWT': localStorage.getItem('token') || ''
            }
          });
          
          if (progressionResponse.ok) {
            if (onWorkflowProgressRefresh) {
              onWorkflowProgressRefresh();
            }
          } else {
            if (onWorkflowProgressRefresh) {
              onWorkflowProgressRefresh();
            }
          }
        } catch (progressionError) {
          if (onWorkflowProgressRefresh) {
            onWorkflowProgressRefresh();
          }
        }
      }

      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  return (
    <div className="modern-task-container">
      <InlineTaskList
        tasks={taskItems || []}
        onCreateTask={handleCreateTask}
        onUpdateTask={handleUpdateTask}
        onDeleteTask={handleDeleteTask}
        onToggleTask={handleToggleTask}
        onSearchTask={handleSearchTask ? (query: string) => handleSearchTask(query) : () => {}}
      />
    </div>
  );
};

export default LeadDetailsTask;
